import { AsyncSelectInput } from './async-select-input';
import { DropzoneInput } from './dropzone-input';

const Form = {
  asyncSelect: AsyncSelectInput,
  dropzone: DropzoneInput,
} as const;

export { Form };
